import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemPlussparkle = function IconSystemPlussparkle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M12 18.964c-.603-1.897-1.34-3.355-2.474-4.49C8.392 13.34 6.934 12.604 5.037 12c1.897-.603 3.355-1.34 4.49-2.474C10.66 8.39 11.396 6.934 12 5.036c.603 1.898 1.34 3.355 2.473 4.49 1.135 1.135 2.592 1.87 4.49 2.474-1.898.603-3.355 1.34-4.49 2.474-1.134 1.135-1.87 2.593-2.473 4.49Z"
  }));
};